import { createFileRoute } from '@tanstack/react-router';
import { GalleriesPage } from '@/components/marketing/pages/GalleriesPage';

export const Route = createFileRoute('/_marketing/for-galleries')({
  component: GalleriesPage,
});
